import { render, staticRenderFns } from "./courseMuluComponent.vue?vue&type=template&id=17950867"
import script from "./courseMuluComponent.vue?vue&type=script&lang=js"
export * from "./courseMuluComponent.vue?vue&type=script&lang=js"
import style0 from "./courseMuluComponent.vue?vue&type=style&index=0&id=17950867&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports